const PaymentStatus = {
  CREATED: 'CREATED',
  PAID: 'PAID',
  PAID_NOT_REFUNDABLE: 'PAID_NOT_REFUNDABLE',
  REFUNDED: 'REFUNDED',
  FAILED: 'FAIL',
  REFUND_FAILED: 'REFUND_FAILED',
}

export default PaymentStatus
